export function StateIndia(){
  return [
    {
    "key": "AN",
    "name": "Andaman and Nicobar Islands",
    "applicability":"leave_working_hr"
    },
    {
    "key": "AP",
    "name": "Andhra Pradesh",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "AR",
    "name": "Arunachal Pradesh",
    "applicability":"leave_working_hr"
    },
    {
    "key": "AS",
    "name": "Assam",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "BR",
    "name": "Bihar",
    "applicability":"pt,leave_working_hr"
    },
    {
      "key":"CEN",
      "name":"Central",
      "applicability":"leave_working_hr"
    },
    {
    "key": "CG",
    "name": "Chandigarh",
    "applicability":"lwf,leave_working_hr"
    },
    {
    "key": "CH",
    "name": "Chhattisgarh",
    "applicability":"lwf,leave_working_hr"
    },
    {
    "key": "DH",
    "name": "Dadra and Nagar Haveli",
    "applicability":"leave_working_hr"
    },
    {
    "key": "DD",
    "name": "Daman and Diu",
    "applicability":"leave_working_hr"
    },
    {
    "key": "DL",
    "name": "Delhi",
    "applicability":"lwf,leave_working_hr",
    },
    {
    "key": "GA",
    "name": "Goa",
    "applicability":"lwf,leave_working_hr"
    },
    {
    "key": "GJ",
    "name": "Gujarat",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "HR",
    "name": "Haryana",
    "applicability":"lwf,leave_working_hr"
    },
    {
    "key": "HP",
    "name": "Himachal Pradesh",
    "applicability":"leave_working_hr"
    },
    {
    "key": "JK",
    "name": "Jammu and Kashmir",
    "applicability":"leave_working_hr"
    },
    {
    "key": "JH",
    "name": "Jharkhand",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "KA",
    "name": "Karnataka",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "KL",
    "name": "Kerala",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
      "key":"LA",
      "name":"Ladakh",
      "applicability":"leave_working_hr"
    },
    {
    "key": "LD",
    "name": "Lakshadweep",
    "applicability":"leave_working_hr"
    },
    {
    "key": "MP",
    "name": "Madhya Pradesh",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "MH",
    "name": "Maharashtra",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "MN",
    "name": "Manipur",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "ML",
    "name": "Meghalaya",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "MZ",
    "name": "Mizoram",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "NL",
    "name": "Nagaland",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "OR",
    "name": "Odisha",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "PY",
    "name": "Puducherry",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "PB",
    "name": "Punjab",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "RJ",
    "name": "Rajasthan",
    "applicability":"leave_working_hr"
    },
    {
    "key": "SK",
    "name": "Sikkim",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "TN",
    "name": "Tamil Nadu",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "TS",
    "name": "Telangana",
    "applicability":"lwf,pt,leave_working_hr"
    },
    {
    "key": "TR",
    "name": "Tripura",
    "applicability":"pt,leave_working_hr"
    },
    {
    "key": "UK",
    "name": "Uttar Pradesh",
    "applicability":"leave_working_hr"
    },
    {
    "key": "UP",
    "name": "Uttarakhand",
    "applicability":"leave_working_hr"
    },
    {
    "key": "WB",
    "name": "West Bengal",
    "applicability":"lwf,pt,leave_working_hr"
    }
    ]
}

export function StateMaster(){
  return [
    {"location_id":"2","name":"Andaman and Nicobar Islands","short_name":"AN","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"3","name":"Andhra Pradesh","short_name":"AP","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"4","name":"Arunachal Pradesh","short_name":"AR","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"5","name":"Assam","short_name":"AS","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"6","name":"Bihar","short_name":"BR","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"7","name":"Central","short_name":"CEN","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"8","name":"Chandigarh","short_name":"CG","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"9","name":"Chhattisgarh","short_name":"CH","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"10","name":"Dadra and Nagar Haveli","short_name":"DH","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"11","name":"Daman and Diu","short_name":"DD","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"12","name":"Delhi","short_name":"DL","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"13","name":"Goa","short_name":"GA","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"14","name":"Gujarat","short_name":"GJ","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"15","name":"Haryana","short_name":"HR","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"16","name":"Himachal Pradesh","short_name":"HP","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"17","name":"Jammu and Kashmir","short_name":"JK","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"18","name":"Jharkhand","short_name":"JH","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"19","name":"Karnataka","short_name":"KA","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"20","name":"Kerala","short_name":"KL","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"21","name":"Lakshadweep","short_name":"LD","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"22","name":"Madhya Pradesh","short_name":"MP","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"23","name":"Maharashtra","short_name":"MH","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"24","name":"Manipur","short_name":"MN","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"25","name":"Meghalaya","short_name":"ML","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"26","name":"Mizoram","short_name":"MZ","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"27","name":"Nagaland","short_name":"NL","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"28","name":"Odisha","short_name":"OR","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"29","name":"Puducherry","short_name":"PY","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"30","name":"Punjab","short_name":"PB","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"31","name":"Rajasthan","short_name":"RJ","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"32","name":"Sikkim","short_name":"SK","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"33","name":"Tamil Nadu","short_name":"TN","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"34","name":"Telangana","short_name":"TS","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"35","name":"Tripura","short_name":"TR","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"36","name":"Uttar Pradesh","short_name":"UK","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"37","name":"Uttarakhand","short_name":"UP","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""},{"location_id":"38","name":"West Bengal","short_name":"WB","location_type":"1","parent_id":"1","is_visible":"0","location_code":"","status":""}
  ];
}


export default StateIndia;
